// Decides whether a TanStack Query/Mutation error is worth reporting to Sentry.
//
// Expected, handled client errors are noise, not bugs — reporting them buries the real
// failures (500s, network errors) we actually need to jump on. This matters most on
// shared surfaces like the Bulletin Board, where optimistic-concurrency **409**s happen
// routinely (two people editing the same note/column → "someone changed this, refetch").
//
// Skipped (not reported):
//   401 — auth; handled by the auth interceptor / re-login.
//   403 — permission; expected, not a bug (the query handler already treated it this way).
//   409 — optimistic-concurrency / handled-per-mutation; expected and recovered from.
//
// Reported: everything else — 5xx server errors, network failures (no response/status),
// and unexpected 4xx like 400 (malformed request → likely a real frontend bug) and 404.
const EXPECTED_CLIENT_ERROR_STATUSES = new Set([401, 403, 409]);

export function shouldReportToSentry(error: unknown): boolean {
  const status = (error as { response?: { status?: number } } | null)?.response?.status;
  if (status === undefined) return true; // network / no HTTP status → real failure
  return !EXPECTED_CLIENT_ERROR_STATUSES.has(status);
}
